import { ActivitySubTag } from '@percent/admin-dashboard/api/types'

export const sortEducationSubtags = (a: ActivitySubTag, b: ActivitySubTag) => {
  const sortOrder = ['pre primary school', 'primary school', 'secondary school', 'higher education']

  return sortOrder.indexOf(a.name.toLocaleLowerCase()) - sortOrder.indexOf(b.name.toLocaleLowerCase())
}
